const TARGET_PATH_OF_TEXT_SECTION_LINK = `
#main :is(li, p, h1, h2, h3, h4, h5, h6):not(.calendar * ):not(.link-list-wrapper * ) a,
#main-nav :is(li, p, h1, h2, h3, h4, h5, h6):not(.calendar * ):not(.link-list-wrapper * ) a`;

const addExternalLinkIcons = (element) => {
  element.querySelectorAll(TARGET_PATH_OF_TEXT_SECTION_LINK).forEach((anchor) => {
    // detect if the link is external
    const isExternal = anchor.hostname !== window.location.hostname;
    if (!isExternal) {
      return;
    }

    const iconSpan = document.createElement('span');
    iconSpan.className = 'icon icon--inline';
    iconSpan.setAttribute('aria-hidden', 'true');
    iconSpan.setAttribute('focusable', 'false');
    iconSpan.innerText = 'open_in_new';

    anchor.appendChild(iconSpan);

    // open external links in a new tab
    anchor.setAttribute('target', '_blank');

    // add rel="noopener noreferrer" to external links
    // This is a security measure to prevent the new page
    // from being able to access the window.opener property
    // and potentially redirecting the original page to a new URL.
    // See https://web.dev/external-anchors-use-rel-noopener/
    anchor.setAttribute('rel', 'noopener noreferrer');
  });
};

export default addExternalLinkIcons;
